import React from "react";
import { connect } from "react-redux";
import language from "../../../language";
import { fetchApplicationLogs } from "../../../utils/queries/logs/applicationLogsQuery";
import { Table } from "../../../components/Table";
import { Modal } from "../../../components/Modal";
import { Input } from "../../../components/Input";
import ReactJson from "react-json-view";
import icons from "../../../constants/icons";
import "./styles.css";

const ACTION_OPTIONS = [
  { label: "All Actions", value: "" },
  { label: "Labelled", value: "labelled" },
  { label: "Serve Request", value: "serveRequest" },
  { label: "Manual Rejection", value: "manualRejection" },
  { label: "Manual Reverse", value: "manualReverse" },
  { label: "Delete Inventory", value: "deleteInventory" },
  { label: "Create Blood Test", value: "createBloodTest" },
  { label: "Update Blood Test", value: "updateBloodTest" },
  { label: "Delete Blood Test", value: "deleteBloodTesting" },
  { label: "Create", value: "CREATE" },
  { label: "Update", value: "UPDATE" },
  { label: "Delete", value: "DELETE" },
  { label: "Login", value: "LOGIN" },
  { label: "Logout", value: "LOGOUT" },
];

class LogsScreen extends React.Component {
  state = {
    isLoading: false,
    data: [],
    page: 1,
    limit: 20,
    totalPageCount: 1,
    search_text: "",
    showModal: false,
    modalTitle: "",
    selectedLog: {},
    actionFilter: "",
    donationFilter: "",
    startDate: "",
    endDate: "",
  };

  componentDidMount() {
    this.getData(true);
  }

  getData = async (isLoading, search = {}) => {
    try {
      const { page, limit, actionFilter, donationFilter, startDate, endDate } = this.state;

      this.setState({ isLoading });

      const params = {
        page,
        limit,
        ...search,
      };

      if (actionFilter) params.action = actionFilter;
      if (donationFilter) params.donationNumber = donationFilter;
      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;

      const response = await fetchApplicationLogs(params);

      let data = [];
      let count = 0;

      if (response) {
        if (Array.isArray(response)) {
          data = response;
          count = response.length;
        } else if (response.data) {
          data = Array.isArray(response.data) ? response.data : [];
          count = response.count || response.totalPages || data.length;
        }
      }

      this.setState({
        data,
        totalPageCount: count,
        isLoading: false,
      });
    } catch (error) {
      console.error("Error fetching logs:", error);
      this.setState({ isLoading: false });
    }
  };

  handlePagination(page, _tab, limit) {
    this.setState(
      {
        page,
        ...(limit != null && { limit }),
      },
      () => {
        this.getData(true);
      }
    );
  }

  handleShowModal(modalTitle, selectedLog = {}) {
    this.setState({
      showModal: true,
      modalTitle,
      selectedLog,
    });
  }

  handleCloseModal() {
    this.setState({ showModal: false });
  }

  onChangeText(field, e) {
    this.setState({ [field]: e?.target?.value });
  }

  handleRemoteSearch = async (search) => {
    await this.getData(true, {
      q: search || search !== "" ? search : undefined,
    });
  };

  handleActionFilter = async (value) => {
    const actionValue = value?.value ?? value;
    this.setState({ actionFilter: actionValue, page: 1 }, () => {
      this.getData(true);
    });
  };

  handleDateFilter = async (field, e) => {
    this.setState({ [field]: e?.target?.value, page: 1 }, () => {
      this.getData(true);
    });
  };

  handleFilterChange = async (field, e) => {
    this.setState({ [field]: e?.target?.value, page: 1 }, () => {
      this.getData(true);
    });
  };

  clearFilters = () => {
    this.setState(
      {
        search_text: "",
        actionFilter: "",
        donationFilter: "",
        startDate: "",
        endDate: "",
        page: 1,
      },
      () => {
        this.getData(true);
      }
    );
  };

  returnTableHeaders() {
    const lng = this.props.defaultLanguage;

    return [
      {
        title: language[lng].log_date || "Date & Time",
        key: "createdAt",
        isMoment: true,
        formatTime: "lll",
      },
      {
        title: language[lng].log_action || "Action",
        key: "logAction",
      },
      {
        title: language[lng].log_ip || "IP Address",
        key: "ip",
      },
      {
        title: language[lng].country || "Country",
        key: "country",
      },
      {
        title: language[lng].description || "Description",
        key: "description",
      },
      {
        title: language[lng].actions || "Actions",
        key: "action",
      },
    ];
  }

  renderLogDetail() {
    const { selectedLog } = this.state;
    const lng = this.props.defaultLanguage;

    if (!selectedLog || !selectedLog._id) return null;

    return (
      <div className="card-body">
        <div className="row">
          <div className="col-md-3">
            <Input
              value={
                selectedLog.createdAt
                  ? new Date(selectedLog.createdAt).toLocaleString()
                  : "-"
              }
              label={language[lng].log_date || "Date & Time"}
              disabled
            />
          </div>
          <div className="col-md-3">
            <Input
              value={selectedLog.action || "-"}
              label={language[lng].log_action || "Action"}
              disabled
            />
          </div>
          <div className="col-md-3">
            <Input
              value={selectedLog.addedByEmail || "-"}
              label={language[lng].log_email || "Email"}
              disabled
            />
          </div>
          <div className="col-md-3">
            <Input
              value={selectedLog.ip || "-"}
              label={language[lng].log_ip || "IP Address"}
              disabled
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-3">
            <Input
              value={selectedLog.country || "-"}
              label={language[lng].country || "Country"}
              disabled
            />
          </div>
          <div className="col-md-3">
            <Input
              value={selectedLog.entity || "-"}
              label={language[lng].entity || "Entity"}
              disabled
            />
          </div>
          <div className="col-md-3">
            <Input
              value={selectedLog.entityId || "-"}
              label={language[lng].entity_id || "Entity ID"}
              disabled
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <Input
              value={selectedLog.description || "-"}
              label={language[lng].description || "Description"}
              disabled
            />
          </div>
        </div>

        {selectedLog.newData &&
          Object.keys(selectedLog.newData).length > 0 && (
            <details className="log-json-card" open>
              <summary className="log-json-card-header">
                <span className="log-json-card-title">
                  {language[lng].log_new_data || "New Data"}
                </span>
              </summary>
              <div className="log-json-card-body">
                <ReactJson
                  src={selectedLog.newData}
                  collapsed={2}
                  enableClipboard={false}
                  displayDataTypes={false}
                  theme="monokai"
                />
              </div>
            </details>
          )}

        {selectedLog.oldData &&
          Object.keys(selectedLog.oldData).length > 0 && (
            <details className="log-json-card">
              <summary className="log-json-card-header">
                <span className="log-json-card-title">
                  {language[lng].log_old_data || "Previous Data"}
                </span>
              </summary>
              <div className="log-json-card-body">
                <ReactJson
                  src={selectedLog.oldData}
                  collapsed={2}
                  enableClipboard={false}
                  displayDataTypes={false}
                  theme="monokai"
                />
              </div>
            </details>
          )}
      </div>
    );
  }

  render() {
    const lng = this.props.defaultLanguage;
    const {
      data,
      page,
      limit,
      totalPageCount,
      isLoading,
      search_text,
      showModal,
      modalTitle,
      actionFilter,
      donationFilter,
      startDate,
      endDate,
    } = this.state;

    const enrichedData = data.map((item) => ({ ...item, logAction: item.action }));

    return (
      <>
        <Table
          data={enrichedData}
          isSearch
          page={page}
          limit={limit}
          search_text={search_text}
          addSearchButton
          handleSearch={(e) => this.onChangeText("search_text", e)}
          handlePressSearch={() => this.handleRemoteSearch(search_text)}
          totalPageCount={totalPageCount}
          isLoading={isLoading}
          handlePagination={this.handlePagination.bind(this)}
          headers={this.returnTableHeaders()}
          actionFilter={actionFilter}
          donationFilter={donationFilter}
          moreFilters={[
            {
              inputType: "selection",
              options: ACTION_OPTIONS,
              placeholder: language[lng].log_all_actions || "All Actions",
              leftIcon: "filter_alt",
              fieldName: "actionFilter",
              value: actionFilter,
              onChange: this.handleActionFilter,
            },
            {
              inputType: "input",
              placeholder: language[lng].log_filter_donation || "Filter by Donation #",
              leftIcon: "bloodtype",
              fieldName: "donationFilter",
              value: donationFilter,
              onChange: (e) => this.handleFilterChange("donationFilter", e),
            },
            {
              inputType: "input",
              placeholder: language[lng].start_date || "Start Date",
              leftIcon: icons.calendar,
              fieldName: "startDate",
              value: startDate,
              onChange: (e) => this.handleDateFilter("startDate", e),
              type: "date",
            },
            {
              inputType: "input",
              placeholder: language[lng].end_date || "End Date",
              leftIcon: icons.calendar,
              fieldName: "endDate",
              value: endDate,
              onChange: (e) => this.handleDateFilter("endDate", e),
              type: "date",
            },
            {
              inputType: "button",
              text: language[lng].log_clear_filters || "Clear Filters",
              onPress: this.clearFilters,
              className: "btn-secondary",
            },
            {
              inputType: "button",
              text: language[lng].refresh || "Refresh",
              leftIcon: "refresh",
              onPress: () => this.getData(true),
              className: "btn-outline-secondary",
            },
          ]}
          actions={[
            {
              canAccess: true,
              name: language[lng].log_show_details || "View Details",
              icon: icons.eye_on,
              onPress: (item) =>
                this.handleShowModal(
                  language[lng].log_details || "Log Details",
                  item
                ),
            },
          ]}
        />

        <Modal
          handleClose={this.handleCloseModal.bind(this)}
          show={showModal}
          title={modalTitle}
          showHeaderBottomBorder={false}
          size="lg"
        >
          {this.renderLogDetail()}
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(LogsScreen);
